<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="number-one-lesson-in-life">
<h1>1. Number One Lesson in Life</h1>
<p style="text-indent: 00em;">What you want and what you need are often two very diﬀerent things. Now you say it.</p><br/>
<p style="text-indent: 01em;"><em>“What I want and what I need are often two very diﬀerent things.”</em></p><br/>
<p style="text-indent: 00em;">Repeat it.</p><br/>
<p style="text-indent: 01em;"><em>“What I want and what I need are often two very diﬀerent things.”</em></p><br/>
<p style="text-indent: 00em;">Accept it.</p>
<p style="text-indent: 00em;">You want to know everything. You don’t need to know at all. The lessons are the point of life.</p><br/>
<p style="text-indent: 00em;"><em>“Thank you, Universe, for revealing to me what I need to know.”</em></p><br/>
<p style="text-indent: 00em;">‘Need’ is the keyword. Think of cravings. You want meat; you need iron. You want sugar; you need energy.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?e630e208